// For backwards compatibility, create a combined service object
import authService from './auth/authService';
import clientService from './client/clientService';
import accountService from './account/accountService';
import transactionService from './transaction/transactionService';

// Export all services from a single entry point
export { default as authService } from './auth/authService';
export { default as clientService } from './client/clientService';
export { default as accountService } from './account/accountService';
export { default as transactionService } from './transaction/transactionService';
export { default as httpClient } from './base/httpClient';
export { default as userService } from './user/userService';
export { dashboardService } from './dashboard/dashboardService';

// Export types
export type { TransactionFilters, TransactionSummary, TransactionListResponse } from './transaction/transactionService';
export type { DashboardStats, TopPerformer, TopAccount, CommissionTrend } from './dashboard/dashboardService';

export const apiService = {
  // Auth methods
  login: authService.login.bind(authService),
  logout: authService.logout.bind(authService),
  getProfile: authService.getProfile.bind(authService),
  changePassword: authService.changePassword.bind(authService),
  getToken: authService.getToken.bind(authService),
  isAuthenticated: authService.isAuthenticated.bind(authService),

  // Client methods
  getClients: clientService.getClients.bind(clientService),
  getClient: clientService.getClient.bind(clientService),
  createClient: clientService.createClient.bind(clientService),
  updateClient: clientService.updateClient.bind(clientService),
  deleteClient: clientService.deleteClient.bind(clientService),
  toggleClientStatus: clientService.toggleClientStatus.bind(clientService),

  // Account methods
  getAccounts: accountService.getAccounts.bind(accountService),
  getAccount: accountService.getAccount.bind(accountService),
  createAccount: accountService.createAccount.bind(accountService),
  updateAccount: accountService.updateAccount.bind(accountService),
  deleteAccount: accountService.deleteAccount.bind(accountService),
  toggleAccountStatus: accountService.toggleAccountStatus.bind(accountService),
  getAvailableClients: accountService.getAvailableClients.bind(accountService),
};

export default apiService;